import {
  BankAccountResolver,
  ModalContainer,
  SectionHeader,
  SwitchAppButton,
} from "../../../components";
import {
  HookFormSelect,
  SubmitButton,
  TextArea,
  TextInput,
} from "../../../hook-form";
import { filterSupportedCountriesFromList } from "../../../utils";
import { ICreateBankTransferBeneficiaryFormViewProps } from "./CreateBeneficiaryForm";

export const View = ({
  isModalOpen,
  closeModal,
  isLoadingSupportedCountries,
  swAppSupportedCountries,
  isLoadingSupportedCurrencies,
  swAppSupportedCurrencies,
  isLoadingBankList,
  bankList,

  isBankAccountResolved,
  setBankAccountResolved,

  formValues,
  errors,
  handleSubmit,
  register,
}: ICreateBankTransferBeneficiaryFormViewProps) => {
  return (
    <ModalContainer
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      modalHeader={
        <SectionHeader
          title="Add New Beneficiary"
          subtitle="A beneficiary is the recipient of the funds of a bank transfer."
        />
      }
    >
      <form onSubmit={handleSubmit}>
        <div className="flex-container flex-break--small">
          <div className="flex-box">
            <TextInput
              name="full_name"
              label="Alias/Nickname (Optional)"
              infoIconText="Name/alias for you to easily recognize (Optional)"
              type="text"
              register={register}
              errors={errors}
            />
          </div>
          {/* <div className="flex-box ml-md-5">
            <TextInput
              name="xxxxxxxxx"
              label="xxxxxxxxx"
              infoIconText="xxxxxxxxx"
              type="text"
              register={register}
              errors={errors}
            />
          </div> */}
        </div>

        <div className="flex-container flex-break--small">
          <div className="flex-box mr-md-5">
            <TextInput
              name="email"
              label="Email (Optional)"
              infoIconText="Beneficiary Email for notifications"
              type="text"
              register={register}
              errors={errors}
            />
          </div>
          <div className="flex-box">
            <TextInput
              name="phone_number"
              label="Phone No (Optional)"
              infoIconText="Beneficiary Phone for notifications"
              type="text"
              register={register}
              errors={errors}
            />
          </div>
        </div>

        <div className="flex-container flex-break--small">
          <div className="flex-box mr-md-5">
            <HookFormSelect
              name="country"
              label="Country"
              infoIconText="Country where the withdrawal bank account is located"
              showSkeleton={isLoadingSupportedCountries}
              selectItems={[]}
              selectGroupedItems={filterSupportedCountriesFromList(
                swAppSupportedCountries
              )}
              register={register}
              errors={errors}
            />
          </div>
          <div className="flex-box">
            <HookFormSelect
              name="currency"
              label="Currency"
              infoIconText="The currency of the withdrawal bank account eg USD"
              showSkeleton={isLoadingSupportedCurrencies}
              selectItems={swAppSupportedCurrencies.map((cur) => ({
                text: `${cur.currency_name} (${cur.currency_symbol})`,
                value: cur.currency,
              }))}
              register={register}
              errors={errors}
              disabled={!formValues.country}
            />
          </div>
        </div>

        <div className="flex-container flex-break--small">
          <div className="flex-box mr-md-5">
            <HookFormSelect
              name="bank_code"
              label="Bank"
              infoIconText="The withdrawal bank"
              showSkeleton={isLoadingBankList}
              selectItems={bankList.map((bnk) => ({
                text: bnk.bank_name,
                value: bnk.bank_code,
              }))}
              register={register}
              errors={errors}
              disabled={!formValues.country || !formValues.currency}
            />
          </div>
          <div className="flex-box">
            <TextInput
              name="account_number"
              label="Account Number"
              infoIconText="The withdrawal account number"
              type="text"
              register={register}
              errors={errors}
            />

            <div className="flex-container">
              <BankAccountResolver
                accountNumber={formValues.account_number}
                bankCode={formValues.bank_code}
                country={formValues.country}
                currency={formValues.currency}
                isBankAccountResolved={isBankAccountResolved}
                setBankAccountResolved={setBankAccountResolved}
              />
            </div>
          </div>
        </div>

        <div className="flex-container col">
          <TextArea
            name="description"
            label="Description (Optional)"
            infoIconText="More info about this beneficiary."
            register={register}
            errors={errors}
          />
        </div>

        <div className="flex-container justify-content--end mt-5">
          <div
            id="md_alignment_helper"
            className="flex-box flex-1_5 d-none d-md-flex"
          />
          <div className="flex-box flex-container">
            <SwitchAppButton kind="secondary" onClick={closeModal} size="sm">
              Cancel
            </SwitchAppButton>

            <SubmitButton
              size="sm"
              className="ml-5"
              disabled={!isBankAccountResolved}
            >
              Save
            </SubmitButton>
          </div>
        </div>
      </form>
    </ModalContainer>
  );
};
